import CampaignsList from '@/views/Admin/CampaignsList/CampaignsList.vue';
import { Route } from '../route.model';

const adminCampaignsList = new Route(
  '/admin/campaigns-list',
  'campaigns_list',
  CampaignsList,
  {
    isResponsive: true,
    requiresAuth: true,
    superRoot: true,
    navbar: {
      name: 'Referral Campaigns', // TODO apply i18n
      icon: 'social-rewards'
    },
    zendesk: {
      disabled: true
    }
  }
);

export { adminCampaignsList };
export default adminCampaignsList;
